import Minze, { EventListeners, MinzeAttrs, MinzeElement, Reactive } from 'minze'
import { Font } from '../../constants'
import { Locale } from '../../modules/locale'

Locale.getInstance().registerKeySet('fr', 'discoveryPaywall', {
  title: 'Pas encore de compte?',
  description: "Créer mon compte pour découvrir des événements selon mes goûts. C'est gratuit!",
  login: 'Me connecter',
  register: "M'inscrire",
})

Locale.getInstance().registerKeySet('en', 'discoveryPaywall', {
  title: 'Still don’t have an account?',
  description: 'Create an account to see events you might like. It’s free!',
  login: 'Sign in',
  register: 'Sign up',
})

export class LvcDiscoveryPaywall extends MinzeElement {
  html = () => `
    <h1 class="title">${Locale.getKey('discoveryPaywall.title')}</h1>
    <lvc-box class="items-container" display="flex" flexDirection="column" alignItems="center" mb="24px">
      <lvc-charlie-ecoute-icon width="235" height="235"></lvc-charlie-ecoute-icon>
      <p class="description">${Locale.getKey('discoveryPaywall.description')}</p>
      <lvc-box>
        <slot class="interaction"></slot>
      </lvc-box
    </lvc-box>
    
  `

  css = () => `
    :host {
      max-width: 540px;
      width: 100%;
      margin: 0 auto;
    }
    .title {
      text-align: center;
      font-size: 60px;
      font-weight: ${Font.weight.extraBold};
      line-height: 1;
      margin: 0 0 24px;
    }
    .description {
      text-align: center;
      font-size: 20px;
      margin: 0 0 40px 0;
    }
    .items-container {
      position: relative;
    }
    lvc-charlie-ecoute-icon {
      position: absolute;
      right: 0;
      margin-right: -235px;
      top: 50%;
      margin-top: -117.5px;
    }
    @media screen and (max-width: 991px) {
      .description {
        text-align: center;
        font-size: 16px;
        margin-bottom: 24px;
      }
      .title {
        font-size: 48px;
        margin-bottom: 0px;
      }
      lvc-charlie-ecoute-icon {
        margin: 0;
        position: static;
      }
      lvc-charlie-ecoute-icon::part(image) {
          width: 158px;
          height: 158px;
      }
    }
    @media screen and (max-width: 540px) {
      .description {
        font-size: 14px;
        margin-bottom: 16px;
      }
      .title {
        font-size: 24px;
      }
    }
  `
}
